<template>
  <el-dialog
    :visible.sync="visible"
    :title="!dataForm.id ? '新增' : dataForm.luckyDrawDTO.status === 4 ? '修改':'活动细则'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close='closeHandle'
  >
    <el-form
      :disabled="dataForm.luckyDrawDTO.status === 4 ? false : dataForm.id ? true : false"
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmitHandle()"
      :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'"
    >
      <el-form-item label="活动名称" prop="luckyDrawDTO.name">
        <el-input v-model="dataForm.luckyDrawDTO.name" placeholder="活动名称"></el-input>
      </el-form-item>
      <el-form-item label="活动时间" prop="luckyDrawDTO.startTime">
        <el-date-picker
          v-model="dataForm.luckyDrawDTO.startTime"
          type="datetime"
          :disabled="timeLimited"
          value-format="timestamp"
          placeholder="年/月/日"
        ></el-date-picker>&nbsp;至&nbsp;
        <el-date-picker
          prop="luckyDrawDTO.endTime"
          v-model="dataForm.luckyDrawDTO.endTime"
          type="datetime"
          value-format="timestamp"
          placeholder="年/月/日"
          @change="changeEndTime(dataForm.luckyDrawDTO.endTime)"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="活动规则" prop="describe">
        <quill quillId="describe" ref="quills"></quill>
      </el-form-item>

      <el-form-item
        prop="luckyDrawDTO.partake"
        label="参与用户"
        :disabled="dataForm.luckyDrawDTO.id?true:false"
      >
        <el-checkbox-group v-model="dataForm.luckyDrawDTO.partake">
          <el-checkbox label="mMIN">迷你</el-checkbox>
          <el-checkbox label="mSTD">标准</el-checkbox>
          <el-checkbox label="mVIP">金钻</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <div style="display: flex">
        <el-form-item label="抽奖上限" >
          <el-select v-model="dataForm.luckyDrawDTO.luckyDrawStatus" placeholder="请选择">
            <el-option
                    v-for="item in luckyDrawStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
          最多可获得
        </el-form-item>

        <el-form-item prop="luckyDrawSum" style="margin-left: -80px;">

          <el-input style="width:100px" v-model="dataForm.luckyDrawDTO.luckyDrawSum"  @keydown="handleInput2"></el-input>次抽奖机会
        </el-form-item>
      </div>

      <div style="color:#0096dc;margin-bottom:10px;cursor:pointer;float: left;
    width: 80px;" @click="addContion()">
        +添加条件组
      </div>
      <el-form-item label="参与条件">

        <condition-list
          v-for="(item,index) in dataForm.luckyDrawConditions"
          :key="index"
          :listLiData="item"
          @deletelist="deletelist"
        ></condition-list>
      </el-form-item>
    </el-form>

    <el-form class="price_set" :disabled="dataForm.luckyDrawDTO.status === 4 ? false : dataForm.id ? true : false">
      <el-form-item label="奖品设置">
        <span @click="addLine()" style="color:#0096dc;margin-bottom:10px;cursor:pointer">+添加奖品</span>
        <el-table :data="dataForm.luckyDrawPrizes" border style="width: 100%">
          <el-table-column fixed type="index"  label="序号" :index="indexMethod" width="80"></el-table-column>
          <el-table-column prop="name" label="奖项" width="150">
            <template scope="scope">
              <el-input size="small" v-model="scope.row.name" placeholder="如奖品"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="bonus" label="奖品" width="180">
            <template scope="scope">
              <el-input-number
                size="small"
                v-model="scope.row.bonus"
                :num="0"
                :min="0"
                controls-position="right"
              ></el-input-number>美元
            </template>
          </el-table-column>
          <el-table-column prop="number" label="奖品数量" width="180">
            <template scope="scope">
              <el-input-number
                size="small"
                v-model="scope.row.number"
                :num="0"
                :min="0"
                controls-position="right"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="probabilityMin" label="概率-迷你" width="180">
            <template scope="scope">
              <el-input-number
                size="small"
                v-model="scope.row.probabilityMin"
                :num="0"
                :min="0"
                controls-position="right"
              ></el-input-number>%
            </template>
          </el-table-column>
          <el-table-column prop="probabilityStd" label="概率-标准" width="180">
            <template scope="scope">
              <el-input-number
                size="small"
                v-model="scope.row.probabilityStd"
                :num="0"
                :min="0"
                controls-position="right"
              ></el-input-number>%
            </template>
          </el-table-column>
          <el-table-column prop="probabilityVip" label="概率-金钻" width="180">
            <template scope="scope">
              <el-input-number
                size="small"
                v-model="scope.row.probabilityVip"
                :num="0"
                :min="0"
                controls-position="right"
              ></el-input-number>%
            </template>
          </el-table-column>
          <el-table-column prop="dayUpperLimit" label="单日上限" width="180">
            <template scope="scope">
              <el-input-number
                size="small"
                v-model="scope.row.dayUpperLimit"
                :num="0"
                :min="0"
                controls-position="right"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="sumUpperLimit" label="总上限" width="180">
            <template scope="scope">
              <el-input-number
                size="small"
                v-model="scope.row.sumUpperLimit"
                :num="0"
                :min="0"
                controls-position="right"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="handleDeleteClick1(scope.row.id==null|| scope.row.id==undefined ? scope.row.index:scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>

    <el-form class="price_set" :disabled="dataForm.luckyDrawDTO.status === 4 ? false : dataForm.id ? true : false">
      <el-form-item label="特殊设置">
        <span @click="addLine1()" style="color:#0096dc;margin-bottom:10px;cursor:pointer">+添加</span>
        <el-table :data="dataForm.luckyDrawSpecials" border style="width: 100%">
          <el-table-column fixed type="index" label="序号" :index="indexMethod" width="130"></el-table-column>
          <el-table-column prop="name" label="中奖手机号" width="350">
            <template scope="scope">
              <el-input size="small" v-model="scope.row.phone" placeholder="中奖手机号"></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="name" label="奖项" width="200">
            <template scope="scope">
              <el-input size="small" v-model="scope.row.name" placeholder="如，一等奖"></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="bonus" label="奖品" width="210">
            <template scope="scope">
              <el-input-number
                size="small"
                v-model="scope.row.bonus"
                :num="0"
                controls-position="right"
              ></el-input-number>美元
            </template>
          </el-table-column>

          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="handleDeleteClick(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>

    <template slot="footer">
      <el-button v-if="dataForm.luckyDrawDTO.status === 4 || !dataForm.id" @click="closeHandle()">取消</el-button>
      <el-button v-else @click="closeHandle()">关闭</el-button>
      <el-button v-if="dataForm.luckyDrawDTO.status === 4 || !dataForm.id" type="primary" @click="dataFormSubmitHandle()">确认</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import quill from "./import/table/quill.vue";
import conditionList from "./components/conditionList";
import Url from '@/views/crs/util/url';
export default {
  components: {
    quill,
    conditionList
  },
  props: ["productList"],
  data() {
    return {
      index0: -100,
      index1: -100,
      visible: false,
      timeLimited: false,
      OldEndTime: "",
      addNum: 0,
      luckyDrawStatusOptions: [
        {
          value: 1,
          label: "活动期"
        },
        {
          value: 2,
          label: "每日"
        }
      ],
      tradePlatformOptions: [
        {
          value: "GTS2",
          label: "PTS"
        },
        {
          value: "MT4",
          label: "MT4"
        }
      ],
      dataForm: {
        id: "",
        luckyDrawDTO: {
          id: "",
          name: "",
          nameEn:"",
          nameVn:"",
          startTime: "",
          endTime: "",
          describe: "",
          describeEn: "",
          describeVn: "",
          partake: [],
          status: "",
          luckyDrawStatus:1,
          luckyDrawSum:0,
          type:1,
          creator: "",
          createDate: "",
          updater: "",
          updateDate: "",
          tradePlatform:""
        },
        luckyDrawConditions: [
          {
            luckyDrawId: "",
            groupId: "",
            startTime: "",
            endTime: "",
            count: "",
            repeat: 0,
            luckyDrawConditionEntities: [
              {
                type: "3",
                typeOption: [
                  // {
                  //   value: "1",
                  //   label: "开户成功"
                  // },
                  {
                    value: "2",
                    label: "登录成功"
                  },
                  {
                    value: "3",
                    label: "净入金"
                  },
                  {
                    value: "4",
                    label: "交易手数"
                  },
                  {
                    value: "5",
                    label: "交易产品"
                  },
                  {
                    value: "6",
                    label: "平仓总盈亏"
                  },
                  /*{
                    value: "7",
                    label: "账户总净值"
                  }*/
                ],
                typeValue: "1",
                conditionsProductType:[],
                productList: [],
                conditionsValue: [],
                typeValueOption: [
                  {
                    value: "1",
                    label: "为真"
                  },
                  {
                    value: "2",
                    label: "为假"
                  }
                ]
              }
            ]
          }
        ],
        luckyDrawPrizes: [
          {
            id: "",
            index: "",
            luckyDrawId: "",
            name: "",
            bonus: "",
            number: "",
            probabilityMin: "",
            probabilityStd: "",
            probabilityVip: "",
            dayUpperLimit: "",
            sumUpperLimit: ""
          }
        ],
        luckyDrawSpecials: [
          {
            id: "",
            luckyDrawId: "",
            phone: "",
            name: "",
            bonus: ""
          }
        ],
        isBy: ""
      }
    };
  },
  computed: {
    dataRule() {
      return {
        "luckyDrawDTO.name": [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur"
          }
        ],
        "luckyDrawDTO.nameEn": [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur"
          }
        ],
        "luckyDrawDTO.nameVn": [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur"
          }
        ],
        "luckyDrawDTO.startTime": [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur"
          }
        ],
        "luckyDrawDTO.endTime": [
          {
            required: false,
            message: this.$t("validate.required"),
            trigger: "blur"
          }
        ],
        "luckyDrawDTO.tradePlatform": [
          {
            required: true,
            message: this.$t("validate.required"),
          }
        ],
        // "luckyDrawDTO.partake": [
        //   {
        //     required: true,
        //     message: this.$t("validate.required"),
        //     trigger: "blur"
        //   }
        // ],
        status: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur"
          }
        ]
      };
    }
  },
  methods: {
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.id) {
          this.getInfo("0");
        } else {
          this.$refs.quills.init("");
          this.$refs.quills1.init("");
          this.$refs.quills2.init("");
          this.dataForm.luckyDrawDTO.endTime=null;
          this.dataForm.isBy=null;
          this.timeLimited = false;
          this.dataForm.luckyDrawConditions = [];
          this.dataForm.luckyDrawPrizes = [];
          this.dataForm.luckyDrawSpecials = [];
          this.addLine();
          this.addLine1();
          this.addContion();
        }
      });
    },
    initCopy() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        this.getInfo("1");
        this.dataForm.id = null;
        this.dataForm.luckyDrawDTO.id = null;

      });
    },
    indexMethod(index) {
      return index;
    },
    changeEndTime(val) {
      if (this.dataForm.id) {
        if (val < this.OldEndTime) {
          this.dataForm.luckyDrawDTO.endTime = this.OldEndTime;
          this.$message("结束时间只能往后延期，请谨慎操作");
        }
      } else {
        return;
      }
    },handleInput2(e) {
    // 通过正则过滤小数点后两位
    e.target.value = (e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null

  },
    // 获取信息
    getInfo(copy) {
      this.$axios
        .get(`${Url.luckyDraw.base}/activity/luckyDraw/${this.dataForm.id}`)
        .then(res => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data
          };
          this.OldEndTime = res.data.luckyDrawDTO.endTime;
          this.dataForm.luckyDrawDTO.startTime = new Date(this.dataForm.luckyDrawDTO.startTime).getTime();
          this.dataForm.luckyDrawDTO.endTime = new Date(this.dataForm.luckyDrawDTO.endTime).getTime();
          for (let i in this.dataForm.luckyDrawConditions) {
            this.dataForm.luckyDrawConditions[i].startTime = new Date(this.dataForm.luckyDrawConditions[i].startTime).getTime();
            this.dataForm.luckyDrawConditions[i].endTime = new Date(this.dataForm.luckyDrawConditions[i].endTime).getTime();
            for (let j in this.dataForm.luckyDrawConditions[i]
              .luckyDrawConditionEntities) {
              if (this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[j].type == 5) {
                const val = this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[j].conditionsProductType;
                const url =
                        val != null && val != ""
                                ? "/product/" + val
                                : "/product/2,4,5,7";
                let _this = this;
                let temProduct = [];
                this.$axios.get(Url.luckyDraw.base + '/activity/luckyDraw' + url).then(res => {
                  if (res.code == 0) {
                    Object.keys(res.data).forEach(function(key) {
                      temProduct.push(
                              Object.assign(
                                      {},
                                      { value: res.data[key], label: key }
                              )
                      );
                    });
                    const allSelect = {
                      value: "全选",
                      label: "allSelect"
                    };
                    temProduct.unshift(allSelect);

                    this.$set(this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[j], "productList", temProduct);
                  }
                });

                this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[j].conditionsValue
                        = this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[j].typeValue.split(",");
                this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[j].conditionsProductType
                        = this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[j].conditionsProductType.split(",");

              }
            }
          }
          if (res.data.isBy == 1) {
            this.timeLimited = true;
          } else {
            this.timeLimited = false;
          }
          if(copy == "1" || copy == 1){
              //复制内容，时间不禁用
              this.timeLimited = false;
              this.dataForm.isBy=null;
              this.dataForm.luckyDrawDTO.status=null;
              for(let i in this.dataForm.luckyDrawConditions){
                this.dataForm.luckyDrawConditions[i].id=i;
                for (let j in this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities){
                  this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[j].id=j;
                }
              }
              for(let i in this.dataForm.luckyDrawPrizes){
                this.dataForm.luckyDrawPrizes[i].id=i;
              }
              for(let i in this.dataForm.luckyDrawSpecials){
                this.dataForm.luckyDrawSpecials[i].id =i;
              }
              // console.log(JSON.stringify(this.dataForm))
          }
          this.$refs.quills.init(this.dataForm.luckyDrawDTO.describe);
          if (
            this.dataForm.luckyDrawDTO.partake != null &&
            this.dataForm.luckyDrawDTO.partake != "" &&
            this.dataForm.luckyDrawDTO.partake.indexOf(",") != -1
          ) {
            this.dataForm.luckyDrawDTO.partake = this.dataForm.luckyDrawDTO.partake.split(
              ","
            );
          } else {
            if( this.dataForm.luckyDrawDTO.partake != null && this.dataForm.luckyDrawDTO.partake != ""){
              let partake1=this.dataForm.luckyDrawDTO.partake;
              this.dataForm.luckyDrawDTO.partake = [];
              this.dataForm.luckyDrawDTO.partake.push(partake1);
            }else{
              this.dataForm.luckyDrawDTO.partake = [];
            }

          }
        })
        .catch(() => {});
    },

    addLine() {
      if(this.dataForm.isBy == "1" || this.dataForm.luckyDrawDTO.status =="2"){
        this.$message({
          message: '活动已开始，不可增加',
          type: 'warning'
        });
        return;
      }
      this.dataForm.luckyDrawPrizes.push({
        //id: this.index0,
        luckyDrawId: "",
        name: "",
        bonus: Number(0).toFixed(3),
        number: Number(0).toFixed(3),
        probabilityMin: Number(0).toFixed(3),
        probabilityStd: Number(0).toFixed(3),
        probabilityVip: Number(0).toFixed(3),
        dayUpperLimit: Number(0).toFixed(3),
        sumUpperLimit: Number(0).toFixed(3)
      });
      this.index0++;
    },
    addLine1() {
      if(this.dataForm.isBy == "1" || this.dataForm.luckyDrawDTO.status =="2"){
        this.$message({
          message: '活动已开始，不可增加',
          type: 'warning'
        });
        return;
      }
      this.dataForm.luckyDrawSpecials.push({
        //id: this.index1,
        luckyDrawId: "",
        phone: "",
        name: "",
        bonus: ""
      });
      this.index1++;
    },
    addContion() {
      if(this.dataForm.isBy == "1"){
        this.$message({
          message: '活动已开始，不可增加',
          type: 'warning'
        });
        return;
      }
      // let length = this.dataForm.luckyDrawConditions.length;
      // if (length > 2) {
      //   this.$message("添加不能超过3条");
      //   return;
      // }
      this.dataForm.luckyDrawConditions.push({
        index: this.addNum,
        status: 1,
        statusOptions: [
          {
            value: 1,
            label: "活动期"
          },
          {
            value: 2,
            label: "每日"
          }
        ],

        luckyDrawConditionEntities: [
          {
            type: "3",
            typeOption: [
              // {
              //   value: "1",
              //   label: "开户成功"
              // },
              {
                value: "2",
                label: "登录成功"
              },
              {
                value: "3",
                label: "净入金"
              },
              {
                value: "4",
                label: "交易手数"
              },
              {
                value: "5",
                label: "交易产品"
              },
              {
                value: "6",
                label: "平仓总盈亏"
              }/*,
              {
                value: "7",
                label: "账户总净值"
              }*/
            ],
            typeValue: "1",
            proTypeValue: [],
            conditionsProductType:[],
            productList: [],
            conditionsValue: [],
            typeValueOption: [
              {
                value: "1",
                label: "为真"
              },
              {
                value: "2",
                label: "为假"
              }
            ]
          }
        ]
      });
      this.addNum++;
    },
    deletelist(idIndex) {
      if(this.dataForm.isBy == "1"){
        this.$message({
          message: '活动已开始，不可删除',
          type: 'warning'
        });
        return;
      }
      if(this.dataForm.luckyDrawConditions.length == 1){
        this.$message({
          message: '最少存在一个条件组',
          type: 'warning'
        });
        return
      }
      let arrIndex = "";
      if (idIndex.id) {
        for (let i in this.dataForm.luckyDrawConditions) {
          if (this.dataForm.luckyDrawConditions[i].id == idIndex.id) {
            arrIndex = i;
          }
        }
      } else {
        for (let i in this.dataForm.luckyDrawConditions) {
          if (this.dataForm.luckyDrawConditions[i].index == idIndex.index) {
            arrIndex = i;
          }
        }
      }
      this.dataForm.luckyDrawConditions.splice(arrIndex, 1);
    },
    handleDeleteClick(id) {
      if (this.dataForm.luckyDrawSpecials.length <= 1) {
        this.$message({
          message: '最少存在一条特殊设置',
          type: 'warning'
        });
        return;
      }
      this.$confirm('是否删除特殊设置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if(id!=null && id !=='' && id != undefined){
          const url = Url.luckyDraw.base+"/activity/luckyDraw/specialDelete?id=" + id;
          this.$axios.delete(url).then(res => {
            if (res.code != 0) {
              return this.$message.error(res.msg);
            } else {
              this.$message({
                message: "删除特殊设置成功！",
                type: "success"
              });
              let arrIndex;

              if (id!=null && id != "") {
                for (let i in this.dataForm.luckyDrawSpecials) {
                  if (this.dataForm.luckyDrawSpecials[i].id == id) {
                    arrIndex = i;
                  }
                }
              } else {
                for (let i in this.dataForm.luckyDrawSpecials) {
                  if (this.dataForm.luckyDrawSpecials[i].index == index) {
                    arrIndex = i;
                  }
                }
              }
              this.dataForm.luckyDrawSpecials.splice(arrIndex, 1);
            }
          });
        }else{
          this.dataForm.luckyDrawSpecials.splice(1, 1);
          this.$message({
            message: "删除奖品设置成功！",
            type: "success"
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleDeleteClick1(id) {
      if (this.dataForm.luckyDrawPrizes.length <= 1) {
        this.$message({
          message: '最少存在一条奖品设置',
          type: 'warning'
        });
        return;
      }
        this.$confirm('是否删除奖品设置?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(id!=null && id !=='' && id != undefined){
            const url = Url.luckyDraw.base+"/activity/luckyDraw/prizeDelete?id=" + id;
            this.$axios.delete(url).then(res => {
              if (res.code != 0) {
                return this.$message.error(res.msg);
              } else {
                this.$message({
                  message: "删除奖品设置成功！",
                  type: "success"
                });
                let arrIndex;

                if (id!=null && id != "") {
                  for (let i in this.dataForm.luckyDrawPrizes) {
                    if (this.dataForm.luckyDrawPrizes[i].id == id) {
                      arrIndex = i;
                    }
                  }
                } else {
                  for (let i in this.dataForm.luckyDrawPrizes) {
                    if (this.dataForm.luckyDrawPrizes[i].index == index) {
                      arrIndex = i;
                    }
                  }
                }
                this.dataForm.luckyDrawPrizes.splice(arrIndex, 1);
              }
            });
          }else{
            alert(id);
            this.dataForm.luckyDrawPrizes.splice(id, 1);
            this.$message({
              message: "删除奖品设置成功！",
              type: "success"
            });
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    closeHandle(){
      this.visible = false;
      location.reload();
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate(valid => {
          if (!valid) {
            return false;
          }
          if (this.dataForm.luckyDrawConditions.length == 0) {
            this.$message("至少添加一个条件组");
            return;
          }

          for (let i in this.dataForm.luckyDrawConditions) {
            for (let j in this.dataForm.luckyDrawConditions[i]
              .luckyDrawConditionEntities) {
              if (
                this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[
                  j
                ].type == 5
              ) {
                let arr01 = this.dataForm.luckyDrawConditions[i]
                  .luckyDrawConditionEntities[j].conditionsProductType;
                this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[
                  j
                ].conditionsProductType = arr01.join(",");
                let arr02 = this.dataForm.luckyDrawConditions[i]
                  .luckyDrawConditionEntities[j].conditionsValue;
                this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[
                  j
                ].typeValue = arr02.join(",");
              }else{
                this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[j].conditionsProductType = ""
              }

            }
          }
          this.dataForm.luckyDrawDTO.describe = this.$refs.quills.getHtml();

          if (
            this.dataForm.luckyDrawDTO.partake != null &&
            this.dataForm.luckyDrawDTO.partake != ""
          ) {
            this.dataForm.luckyDrawDTO.partake = this.dataForm.luckyDrawDTO.partake.join(",");
          } else {
            this.dataForm.luckyDrawDTO.partake = "";
          }
          this.dataForm.luckyDrawDTO.id = this.dataForm.id;

          if (
            this.dataForm.luckyDrawDTO.id == null ||
            this.dataForm.luckyDrawDTO.id == ""
          ) {
            for (let lucky in this.dataForm.luckyDrawConditions) {
              this.dataForm.luckyDrawConditions[lucky].luckyDrawId = null;
            }
            for (let lucky in this.dataForm.luckyDrawPrizes) {
              this.dataForm.luckyDrawPrizes[lucky].luckyDrawId = null;
            }
            for (let lucky in this.dataForm.luckyDrawSpecials) {
              this.dataForm.luckyDrawSpecials[lucky].luckyDrawId = null;
            }
          }
          for(let prize in this.dataForm.luckyDrawPrizes){
            this.dataForm.luckyDrawPrizes[prize].bonus=parseFloat(this.dataForm.luckyDrawPrizes[prize].bonus).toFixed(3);
            this.dataForm.luckyDrawPrizes[prize].probabilityMin=parseFloat(this.dataForm.luckyDrawPrizes[prize].probabilityMin).toFixed(3);
            this.dataForm.luckyDrawPrizes[prize].probabilityStd=parseFloat(this.dataForm.luckyDrawPrizes[prize].probabilityStd).toFixed(3);
            this.dataForm.luckyDrawPrizes[prize].probabilityVip=parseFloat(this.dataForm.luckyDrawPrizes[prize].probabilityVip).toFixed(3);
            this.dataForm.luckyDrawPrizes[prize].dayUpperLimit=parseFloat(this.dataForm.luckyDrawPrizes[prize].dayUpperLimit).toFixed(3);
            this.dataForm.luckyDrawPrizes[prize].sumUpperLimit=parseFloat(this.dataForm.luckyDrawPrizes[prize].sumUpperLimit).toFixed(3);
          }
          this.$axios({
            headers:{"isAjax": 'true', 'Content-Type': 'application/json'},
            method:!this.dataForm.luckyDrawDTO.id ? "post" : "put",
            url:Url.luckyDraw.base+"/activity/luckyDraw/save",
            data:this.dataForm
          }).then(res => {
              if (res.code !== 0) {
                if (this.dataForm.luckyDrawDTO.partake != null && this.dataForm.luckyDrawDTO.partake != "" ) {
                  this.dataForm.luckyDrawDTO.partake = this.dataForm.luckyDrawDTO.partake.split(",");
                } else {
                  this.dataForm.luckyDrawDTO.partake = [];
                }
                for (let i in this.dataForm.luckyDrawConditions) {
                  for (let j in this.dataForm.luckyDrawConditions[i]
                          .luckyDrawConditionEntities) {
                    if (
                            this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[
                                    j
                                    ].type == 5
                    ) {

                      let arr01 = this.dataForm.luckyDrawConditions[i]
                              .luckyDrawConditionEntities[j].conditionsProductType;
                      if(arr01 != null && arr01 != ""){
                        this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[
                                j
                                ].conditionsProductType = arr01.split(",");
                      }else{
                        this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[
                                j
                                ].conditionsProductType = []
                      }
                      let arr02 = this.dataForm.luckyDrawConditions[i]
                              .luckyDrawConditionEntities[j].typeValue;
                      if(arr02 !=null && arr02 != ""){
                        this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[
                                j
                                ].conditionsValue = arr02.split(",");
                      }else{
                        this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[
                                j
                                ].conditionsValue = []
                      }
                    }else{
                      this.dataForm.luckyDrawConditions[i].luckyDrawConditionEntities[j].conditionsProductType = []
                    }

                  }
                }
                return this.$message.error(res.msg);
              }
              this.$message({
                message: "成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                  location.reload();
                }
              });
              this.visible = false;
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    )
  }
};
</script>
<style lang="scss" scoped>
.price_set {
  ul {
    li {
      ul {
        display: flex;
        li {
          width: 50px;
          input {
            width: 50px;
          }
        }
      }
    }
  }
}
ul,
li {
  list-style: none;
}
</style>
